export function httpRequest(method, url, json, options = {}) {
    const { rawResponse = false, ...requestOptions } = options;
    return new Promise(function (resolve, reject) {
        $.ajax({
			type: method,
			url: '/'+url,
            dataType: 'json',
			data: {data: json},
			statusCode: {
				500: function () {
					alert('Server Error, sorry, we be right back!');
				},
			},
            ...requestOptions,
			success: function (response) {
                if (rawResponse || (response && response.success && response.status == 200)) {
                    resolve(response);
                } else {
                    reject(response);
				}
			},
            error: function (response) {
                reject(response);
            }
        });
    });
}
